<template>
  <div>
    <template v-if="!hasPermission">
      <slot
        v-if="!hideUnauthorisedMessage"
        name="unauthorised">
        <UnauthorisedState data-test="no-permission" />
      </slot>
    </template>
    <template v-else>
      <slot name="default" />
    </template>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue';
import { useUserRole, ROLE } from '@/composables/user';
import { UnauthorisedState } from '@/components/ui/common/states';

export default defineComponent({
  name: 'PermissionGate',
  components: {
    UnauthorisedState,
  },
  props: {
    role: {
      type: String,
      required: true,
      validator(value) {
        return Object.values(ROLE).includes(value);
      },
    },
    hideUnauthorisedMessage: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const role = useUserRole();

    return {
      hasPermission: computed(() => role.hasRole(props.role)),
    };
  },
});
</script>
